import { PolicyConferenceRules } from 'src/types'

function Id(value: string | number) {
  if (value === '' || value === null) {
    return null
  }

  return +value || null
}

export default function sanitize(
  values: PolicyConferenceRules
): PolicyConferenceRules {
  const sanitized = JSON.parse(JSON.stringify(values))
  sanitized.policy_conference_id = Id(sanitized.policy_conference_id)

  if (typeof sanitized.policy_conference_rule_id === 'string') {
    sanitized.policy_conference_rule_id = null
  } else {
    sanitized.policy_conference_rule_id = +sanitized.policy_conference_rule_id
  }
  sanitized.policy_request_air_rule_id = Id(
    sanitized.policy_request_air_rule_id
  )
  sanitized.policy_request_general_rule_id = Id(
    sanitized.policy_request_general_rule_id
  )
  sanitized.policy_request_hotel_rule_id = Id(
    sanitized.policy_request_hotel_rule_id
  )
  sanitized.policy_request_vehicle_rule_id = Id(
    sanitized.policy_request_vehicle_rule_id
  )
  return sanitized
}
